import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { DocumentosService } from './documentos.service';
import { TDocumentoSolicitudAtestFitoViewModel, SolicitudDocumentosAtestViewModel } from './documentos.types';
import { UploadedFileViewModel } from '../../../core/components/uploader/document_uploader.types';
import { DocumentUploaderService } from '../../../core/components/uploader/document-uploader.service';
import { TcPerfilUsuarioEnum } from '../../../core/_infrastructure/types/common';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';

@Component({
    selector: 'app-documentos-list',
    templateUrl: './documentos-list.component.html',
})
export class DocumentosListAtestComponent extends ComponentBase implements OnInit {
    solicitudAtestFito: SolicitudDocumentosAtestViewModel;

    uploadedFile: UploadedFileViewModel;

    //pueden descargar documentos siempre estos dos
    EsInspector = false;
    EsCoordinador = false;
    EsConsultas = false;
    EsSolicitante = false;
    habilitarGuardar = false;
    numeroDocumentos = 0;
    cols: any[];
    id = 0;
    editMode = false;
    tituloTipoSolicitudAtest: string;
    codigoTipoSolicitud: string;
    documentoDescargable = false;
    documentoEditable = false;
    documentoBorrable = false;
    IdTipoSolicitudAtestFito: number;

    habilitarNuevoSeguimiento = false;
    seguimientoEditable: boolean;
    seguimientoBorrable: boolean;
    colsObservaciones: any[];
    refAtestFito: string;

    documentosEstandar: TDocumentoSolicitudAtestFitoViewModel[];

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private navMenuService: NavMenuService,
        private uploaderService: DocumentUploaderService,
        private documentosService: DocumentosService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.solicitudAtestFito = new SolicitudDocumentosAtestViewModel();
        this.uploadedFile = new UploadedFileViewModel();
    }

    ngOnInit() {
        this.EsInspector = this.isInspector;
        this.EsCoordinador = this.isCoordinador;
        this.EsConsultas = this.isConsultas;
        this.EsSolicitante = this.isSolicitante;

        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },

            { field: 'Texto', header: 'Descripción' },
            { field: 'NombreArchivo', header: 'Nombre Archivo' },
            { field: 'Fecha', header: 'Fecha' },
            { field: 'IdPerfilAtestFitoDescription', header: 'Perfil' },
        ];

        this.id = this.activatedRoute.snapshot.params['id'];

        this.guardRefreshPage(this.id);

        this.onSearchButton();
    }

    onSearchButton() {
        this.loading = true;

        this.documentosService.getAtestacionDocumentos(this.id).subscribe(result => {
            //console.log(result.TDocumentoSolicitudAtestFitoCollection[0].IdPerfilAtestFitoDescription);

            this.solicitudAtestFito = result;

            this.IdTipoSolicitudAtestFito = this.solicitudAtestFito.IdTipoSolicitudInfCa;
            this.tituloTipoSolicitudAtest = this.solicitudAtestFito.IdTipoSolicitudInfCaDescripcion;
            this.codigoTipoSolicitud = this.solicitudAtestFito.CodigoTipoSolicitud;
            this.refAtestFito = this.solicitudAtestFito.RefAtestFito;

            this.numeroDocumentos = this.solicitudAtestFito.TDocumentoSolicitudAtestFitoCollection!.length;

            //el icono de descargar aparecerá siempre que exista algún documento. La edición se gestiona a continuación
            this.documentoDescargable = this.numeroDocumentos > 0;

            //para el botón de Nuevo
            this.habilitarGuardar = this.loggedInUser!.getAction(
                EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ATESTACION,
                this.solicitudAtestFito.IdEstado,
            ).Visible;
            //para botón Editar/Ver del grid
            this.documentoEditable = this.checkEdit();
            this.documentoBorrable = this.checkDelete();

            this.loading = false;
        });
    }

    checkEdit() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_DOCUMENTOS_ATESTACION, this.solicitudAtestFito.IdEstado).Editable;
    }

    checkDelete() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.GUARDAR_DOCUMENTOS_ATESTACION, this.solicitudAtestFito.IdEstado).Visible;
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudAtestacion.Id) || this.navMenuService.currentSolicitudAtestacion.Id !== id) {
            this.solicitudAtestFitoService.getSolicitudAtestFito(id).subscribe(result => {
                this.navMenuService.currentSolicitudAtestacion = result;
            });
        }
    }

    onBack() {
        this.router.navigate(['/exportacion/atestacion/datosbasicos', this.navMenuService.currentSolicitudAtestacion.Id]);
    }

    onAdd() {
        this.router.navigate([this.router.url, 'create']);
    }

    onEdit(item: TDocumentoSolicitudAtestFitoViewModel) {
        this.router.navigate([this.router.url, 'detalleDocumento', item.Id]);
    }

    onDownload(item: TDocumentoSolicitudAtestFitoViewModel) {
        this.uploadedFile.Guid = item.CodigoStorage;
        this.uploadedFile.Name = item.NombreArchivo;

        this.uploaderService.download(this.uploadedFile).subscribe(res => {
            this.OpenDownloadedFile(res);
        });
    }

    onDelete(item: TDocumentoSolicitudAtestFitoViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.documentosService.deleteDocumento(item.Id).subscribe(() => {
                    this.addSuccessMessage('Documento eliminado correctamente');
                    this.onSearchButton();
                });
            },
        });
    }
}
